.root {
  composes: field from '../field.module.css';
  display: block;
  width: 100%;
  height: 38px;
  padding: 0 12px;
}

.root::placeholder {
  color: var(--ink-3);
}
